export default "__VITE_ASSET__D7cVAH_Z__"